import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment as env } from '../../environments/environment';

export enum PrepSound {
  Bell = 'bell',
  Beep = 'beep',
  Chime = 'chime',
  Alarm = 'alarm',
}

export interface PrepSoundSettings {
  prepSoundEnabled: boolean;
  prepSoundReminderSeconds: number;
  prepSound: PrepSound;
  prepSoundVolume: number;
}

export const DEFAULT_PREP_SOUND_SETTINGS: PrepSoundSettings = {
  prepSoundEnabled: false,
  prepSoundReminderSeconds: 20,
  prepSound: PrepSound.Bell,
  prepSoundVolume: 80,
};

export function resolvePrepSoundSettings(
  source: Partial<PrepSoundSettings> | null | undefined
): PrepSoundSettings {
  return {
    prepSoundEnabled: source?.prepSoundEnabled ?? DEFAULT_PREP_SOUND_SETTINGS.prepSoundEnabled,
    prepSoundReminderSeconds:
      source?.prepSoundReminderSeconds ?? DEFAULT_PREP_SOUND_SETTINGS.prepSoundReminderSeconds,
    prepSound: source?.prepSound ?? DEFAULT_PREP_SOUND_SETTINGS.prepSound,
    prepSoundVolume: source?.prepSoundVolume ?? DEFAULT_PREP_SOUND_SETTINGS.prepSoundVolume,
  };
}

export interface KitchenSettings extends Partial<PrepSoundSettings> {
  kitchenSendThreshold?: number;
  kitchenSendDelayMinutes?: number;
  takeawayDirectHandoverEnabled?: boolean;
  takeawayDirectHandoverDefault?: boolean;
}

@Injectable({ providedIn: 'root' })
export class KitchenSettingsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${env.apiUrl}/restaurants`;

  // Dedicated route, not `PATCH /restaurants/:id`: that one additionally
  // requires restaurant-identity rights, so a RestaurantAdmin would get a 403
  // on a setting it is supposed to own.
  get(restaurantId: string): Observable<KitchenSettings> {
    return this.http.get<KitchenSettings>(`${this.base}/${restaurantId}/kitchen-settings`);
  }

  update(restaurantId: string, payload: KitchenSettings): Observable<KitchenSettings> {
    return this.http.patch<KitchenSettings>(
      `${this.base}/${restaurantId}/kitchen-settings`,
      payload
    );
  }
}
